(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kariyer"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.hifilife').forEach(function(root){
    if(root.dataset.hlInit) return;
    root.dataset.hlInit = '1';

    var ENDPOINT_URL = root.getAttribute('data-endpoint') || '';

    var form = root.querySelector('.hl-form');
    if(!form) return;
    var select = root.querySelector('select[name="position"]');
    var errEl = root.querySelector('.hl-err');
    var btn = root.querySelector('.hl-submitBtn');
    var success = root.querySelector('.hl-success');
    var btnLabel = btn ? btn.textContent : 'Başvuruyu gönder';

    root.querySelectorAll('.hl-role').forEach(function(b){
      b.addEventListener('click', function(){
        if(select) select.value = b.getAttribute('data-position');
        var t = root.querySelector('.hl-apply-sec');
        if(t) t.scrollIntoView({behavior:'smooth'});
        setTimeout(function(){ var n = form.querySelector('[name="name"]'); if(n) n.focus(); }, 500);
      });
    });

    var drop = root.querySelector('.hl-drop');
    var cv = root.querySelector('.hl-cv');
    var filebox = root.querySelector('.hl-filebox');
    var fn = root.querySelector('.hl-fn');
    var fs = root.querySelector('.hl-fs');
    var MAX = 10*1024*1024;
    var chosen = null;

    function fmt(b){ return b<1024*1024 ? (b/1024).toFixed(0)+' KB' : (b/1024/1024).toFixed(1)+' MB'; }
    function showErr(m){ errEl.textContent=m; errEl.classList.add('hl-show'); }
    function clearErr(){ errEl.classList.remove('hl-show'); }
    function setFile(file){
      if(!file) return;
      var ok = /\.(pdf|docx?)$/i.test(file.name) || /pdf|word|document/.test(file.type);
      if(!ok){ showErr('Lütfen PDF, DOC veya DOCX yükle.'); return; }
      if(file.size>MAX){ showErr('Dosya 10 MB sınırını aşıyor.'); return; }
      chosen=file; fn.textContent=file.name; fs.textContent=fmt(file.size); filebox.classList.add('hl-show'); clearErr();
    }
    if(drop){
      drop.addEventListener('click', function(){ cv.click(); });
      drop.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); cv.click(); } });
      ['dragenter','dragover'].forEach(function(ev){ drop.addEventListener(ev, function(e){ e.preventDefault(); drop.classList.add('hl-over'); }); });
      ['dragleave','drop'].forEach(function(ev){ drop.addEventListener(ev, function(e){ e.preventDefault(); drop.classList.remove('hl-over'); }); });
      drop.addEventListener('drop', function(e){ var f=e.dataTransfer.files[0]; if(f){ cv.files=e.dataTransfer.files; setFile(f); } });
    }
    if(cv) cv.addEventListener('change', function(e){ setFile(e.target.files[0]); });
    var rm = root.querySelector('.hl-removeFile');
    if(rm) rm.addEventListener('click', function(){ chosen=null; cv.value=''; filebox.classList.remove('hl-show'); });

    function toBase64(file){ return new Promise(function(res,rej){ var r=new FileReader(); r.onload=function(){res(r.result.split(',')[1]);}; r.onerror=rej; r.readAsDataURL(file); }); }

    form.addEventListener('submit', function(e){
      e.preventDefault(); clearErr();
      var name=form.name.value.trim(), email=form.email.value.trim(), phone=form.phone.value.trim();
      if(!name||!email||!phone){ showErr('Lütfen ad, e-posta ve telefon alanlarını doldur.'); return; }
      if(!select.value){ showErr('Lütfen bir pozisyon seç.'); return; }
      if(!chosen){ showErr('Lütfen CV dosyanı yükle.'); return; }
      var kvkk = root.querySelector('.hl-kvkk');
      if(kvkk && !kvkk.checked){ showErr('Devam etmek için KVKK onayı gerekli.'); return; }

      btn.disabled=true; btn.textContent='Gönderiliyor…';
      toBase64(chosen).then(function(b64){
        var payload={
          name:name, email:email, phone:phone,
          linkedin:form.linkedin.value.trim(), position:select.value, message:form.message.value.trim(),
          filename:chosen.name, mimeType:chosen.type||'application/octet-stream',
          fileBase64:b64, submittedAt:new Date().toISOString()
        };
        var done = function(){
          form.style.display='none';
          success.classList.add('hl-show');
          success.scrollIntoView({behavior:'smooth',block:'center'});
        };
        if(ENDPOINT_URL){
          fetch(ENDPOINT_URL,{method:'POST',mode:'no-cors',headers:{'Content-Type':'text/plain;charset=utf-8'},body:JSON.stringify(payload)})
            .then(done).catch(function(){
              showErr('Gönderim sırasında bir sorun oldu. Lütfen tekrar dene.');
              btn.disabled=false; btn.textContent=btnLabel;
            });
        }else{
          setTimeout(done,700);
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
